module.exports = __webpack_public_path__ + "img/campana-login.fb247ff4.png";